import { useModelStore } from '@editorStores'

const useProjectEarthMassForce = (): number => {
  const project = useModelStore(state => state.project)

  return project.earth_mass_force
}

export default useProjectEarthMassForce
